<template>
  <Drawer :closable="false" v-model="labelDetailsDrawer" width="1000" :title="$t('key1003223')" :transfer="false" :mask="false"
    :mask-closable="false" class-name="labelDetailsStyle" @on-visible-change="labelDetailsChange">
    <template #header>
      <div class="flex align-items-center">
        <Icon type="md-arrow-round-forward" color="#2D8CF0" :size="28" class="cursor" @click="labelDetailsDrawer = false"/>
        <h2 class="font-size-17 font-weight-bold ml10">{{ $t('key1003223') }}</h2>
      </div>
    </template>
    <!--标签基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1003224') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1003208') }}</span>
            <span class="basic_txt">{{ labelInfo.labelValue }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1003225') }}</span>
            <span class="basic_txt">{{ labelInfo.labelTypeName }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--标签数据-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="flex align-items-center">
            <span class="mr10">{{ $t('key1003226') }}</span>
            <Date-picker
              type="daterange"
              style="width: 240px"
              @on-clear="resetDate"
              @on-change="getDateValue"
              :clearable="true"
              transfer
              format="yyyy-MM-dd"
              placement="bottom-end"
              :placeholder="$t('key1000360')"
              :options="dateOptions"
              :value="statisticalTime">
            </Date-picker>
          </div>
        </template>
        <div class="statistical_data_box">
          <div class="statistical_box_item" v-for="item in statisticalData">
            <p class="mb2">{{ item.name }}</p>
            <p>{{ item.value }}</p>
          </div>
        </div>
        <div id="label_echarts"></div>
      </Card>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

var myCharts;
export default {
  name: "labelDetailsDrawer",
  mixins: [Mixin],
  props: {
    tokerLabelTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      ItemCol: 8,
      labelDetailsDrawer: false,
      statisticalData: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003109'), paramsKey: 'numberOfClicks', value: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003110'), paramsKey: 'numberOfRegistrants', value: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003111'), paramsKey: 'registrationConversionRate', value: 0},
      ],
      labelInfo: {},
      statisticalTime: [],
      tokenLabelId: null,
      userInfoList: {}
    };
  },
  mounted() {
    this.initEcharts();
  },
  methods: {
    // 初始化数据
    initlabelDetailsData(tokerLabelId, timer) {
      let v = this;
      v.statisticalTime = timer ? timer : [];
      v.tokenLabelId = tokerLabelId;
      let query = {
        dataView: 0,
        endCreatedTime: timer ? timer[1] : null,
        startCreatedTime: timer ? timer[0] : null,
        tokenLabelId: tokerLabelId,
        source: 'YMS',
      };
      v.labelInfo = {};
      getAllUsersInfo().then((data) => {
        v.userInfoList = data;
        v.axios.post(api.post_ymsTokerLabel_detail, query, {loading: true}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              // 标签基本信息
              if (data.labelValue === 0) {
                v.labelInfo.labelValue = getUserNameByUserId(data.labelValue, v.userInfoList);
              } else {
                v.labelInfo.labelValue = data.labelValue;
              }

              v.tokerLabelTypeList.map((item) => {
                if (item.labelType === data.labelType) {
                  v.labelInfo.labelTypeName = data.labelType;
                }
              });

              // 注册总数
              v.statisticalData.map((item) => {
                if (item.paramsKey === 'registrationConversionRate') {
                  item.value = data[item.paramsKey] + '%';
                } else {
                  item.value = data[item.paramsKey];
                }
              });
              // 分时数据
              let numberList = data.numberList || [];
              if (numberList.length > 0) {
                v.initEcharts(numberList);
              }
              v.$forceUpdate();
            }
          }
        });
      });
      v.labelDetailsDrawer = true;
    },
    // 初始化echarts折线图
    initEcharts(numberList) {
      if (myCharts != null && myCharts != "" && myCharts != undefined) {
        myCharts.dispose();
      }
      myCharts = this.$echarts.init(document.getElementById('label_echarts'));
      let timer = [];
      let numberOfClicks = [];
      let numberOfRegistrants = [];
      if (numberList && numberList.length > 0) {
        numberList.map((item) => {
          timer.push(item.time);
          numberOfClicks.push(item.numberOfClicks);
          numberOfRegistrants.push(item.numberOfRegistrants);
        });
      }

      // 绘制图表
      let options = {
        title: {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003113')
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003114'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003115')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timer,
        },
        yAxis: {
          minInterval: 1
        },
        series: [
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003114'), type: 'line', data: numberOfClicks,},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003115'), type: 'line', data: numberOfRegistrants,}
        ]
      };
      myCharts.setOption(options);
      setTimeout(() => {
        myCharts.resize();
      }, 100);
    },
    // 监听弹窗
    labelDetailsChange(value) {
      if (!value) {

      }
    },
    // 获取统计时间
    getDateValue(value) {
      let v = this;
      let timer = [];
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        v.statisticalTime = value;
        timer = value[0] && value[1] ?
          [v.$uDate.getUniversalTime(new Date(value[0]).getTime()), v.$uDate.getUniversalTime(new Date(value[1]).getTime())] : null;
        v.initlabelDetailsData(v.tokenLabelId, timer);
      }
    },
    // 重置统计时间
    resetDate() {
      this.statisticalTime = [];
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .labelDetailsStyle {
  .ivu-drawer-body {
    background-color: #F0F2F5;
    padding: 0;

    .basic_information_box {
      padding: 12px 12px 0 12px;

      .title_box {
        color: #333;
        font-size: 17px;
        font-weight: bold;
        background-color: #fff;
      }
    }

    .statistical_data_box {
      border-radius: 8px;
      overflow: hidden;
      background: #F1F1F1;
      padding: 10px 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .statistical_box_item {
        font-weight: bold;
        font-size: 13px;
        color: #000;
        text-align: right;
      }
    }

    #label_echarts {
      width: 900px;
      height: 400px;
      margin: 20px auto 0;
    }
  }
}
</style>